import {
  fetchCertainPaymentMethod,
  setBonusCode,
} from '@cashier/cashier-data-access';

export const bonusCodeMiddleware =
  (store: any) => (next: any) => (action: any) => {
    const {
      cashierConfiguration: { paymentType },
      customerInformation: { bonusCode },
      paymentMethod: {
        paymentMethod: { id },
      },
    } = store.getState();

    const result = next(action);

    if (action.type === setBonusCode.toString()) {
      if (bonusCode !== action.payload) {
        store.dispatch(
          fetchCertainPaymentMethod({
            type: paymentType,
            id,
            bonus: action.payload,
          }),
        );
      }
    }

    return result;
  };
